import React from "react";
import { useHistory } from "react-router-dom";
import { cn } from "../../../../utils/classnames";
import { ArrowRightIcon } from "../../../../components/icons";
import { useTranslation } from "react-i18next";

const ActionButtons = ({ getTypographyClass, onReviewChanges, isSimulatingReview, bookingId }) => {
    const {t} = useTranslation();
    const history = useHistory();

    const handleDiscardEdit = () => {
        history.push(bookingId ? `/booking-detail/${bookingId}` : "/my-page/bookings");
    };

    return (
        <div className="tw:flex tw:flex-col-reverse tw:lg:flex-row tw:items-center tw:justify-center tw:gap-2">
            <button type="button" onClick={handleDiscardEdit}>
                <div
                    className={cn(
                        "tw:flex tw:items-center tw:justify-center tw:h-[45px] tw:w-[350px] tw:lg:w-[300px] tw:rounded-[5px] tw:bg-[#f3f3f3] tw:text-[#282828] tw:font-hanken-grotesk",
                        getTypographyClass(14)
                    )}
                >
                    {t("editBooking.BookingEditPage.button.discardEdit")}
                </div>
            </button>
            <button
                type="button"
                onClick={onReviewChanges}
                disabled={isSimulatingReview}
            >
                <div
                    className={cn(
                        "tw:h-[45px] tw:w-[350px] tw:lg:w-[300px] tw:rounded-[5px] tw:bg-[#282828] tw:text-white tw:flex tw:items-center tw:justify-center tw:gap-2 tw:font-hanken-grotesk",
                        getTypographyClass(14),
                        "tw:!font-[700]"
                    )}
                >
                    {isSimulatingReview ? t("editBooking.BookingEditPage.button.reviewing") : t("editBooking.BookingEditPage.button.reviewChanges")}
                    <ArrowRightIcon
                        color="white"
                        size={15}
                        className="tw:inline"
                        aria-label="Arrow Right Icon"
                    />
                </div>
            </button>
        </div>
    );
};

export default ActionButtons;
